// CLASSES
import Settings from "@classes/Settings";


export default function i18n(category, key, lowerCase = false) {
	const fallbackValue = `{{ ${category}.${key} }}`;

	try {
		const result = _getLanguage()[category][key] || fallbackValue;
		return lowerCase === true ? result.toLowerCase() : result;
	} catch (e) {
		return lowerCase === true ? fallbackValue.toLowerCase() : fallbackValue;
	}
}


// PRIVATE FUNCTIONS & DATA
const _getLanguage = () => {
	const langCode = Settings.get("LANGUAGE");
	return _importedLanguages[langCode] || (_importedLanguages[langCode] = require(`@src/i18n/${langCode}.json`));
};

const _importedLanguages = {};


// WEBPACK FOOTER //
// ./src/helpers/i18n.js